import { Icon } from '@abyss/web/ui/Icon';

type Props = {
  size?: number | string;
};

export const CalmIcon = ({ size, ...props }: Props) => (
  <Icon {...props} css={{ width: size || 72, height: 72, marginTop: 20 }}>
    <svg
      height="128"
      viewBox="0 0 128.4 128.4"
      width="128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          gradientTransform="translate(0 130.4) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
          id="linear-gradient"
          x1="63.8"
          x2="63.8"
          y1="2"
          y2="129.6"
        >
          <stop offset="0" stop-color="#3478dd" />
          <stop offset="1" stop-color="#3bbeec" />
        </linearGradient>
        <linearGradient
          gradientTransform="translate(0 130.4) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
          id="linear-gradient1"
          x1="-.2"
          x2="70.3"
          y1="-54.7"
          y2="78.1"
        >
          <stop offset="0" stop-color="#793beb" />
          <stop offset="1" stop-color="#793beb" stop-opacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M98.5,128.4H29.1C13.1,128.4,0,115.3,0,99.3V29.8C0,13.8,13.1.8,29.1.8h69.4c16,0,29.1,13.1,29.1,29.1v69.4c0,16-13.1,29.1-29.1,29.1Z"
        fill="url(#linear-gradient)"
      />
      <path
        d="M98.5,128.4H29.1C13.1,128.4,0,115.3,0,99.3V29.8C0,13.8,13.1.8,29.1.8h69.4c16,0,29.1,13.1,29.1,29.1v69.4c0,16-13.1,29.1-29.1,29.1Z"
        fill="url(#linear-gradient1)"
      />
      <path
        d="M114.9,64.1c-.2-.3-.6-.5-1-.3h0c-.7.4-3.2,1.2-4,1.5-2.9.5-6.5.4-8.3-3.9-.5-1.3-1.1-2.4-2-3.7-1-1.4-4.4-3-7.5,0-.8.7-1.4,1.6-1.9,2.4-.2.3-.4.7-.6,1,0,0,0,0,0-.1-.3-1-1.2-4.5-4.9-5.1-.5,0-2.6-.3-5.4,2.8-1,1.1-1.8,2.2-2.6,3.4,0,0,0,0,0,0-.1-.6-.3-1.2-.5-1.5-2.4-3.7-6.1-.7-7.6.4-3.5,2.5-5.2,5.8-7.3-1.8-.3-1.1-.5-2.1-.7-3.3,2.1-3.6,6.5-14.7,4-22.1-.2-.5-1-2.9-3.1-2.7-.3,0-2.7-.2-4,6.4-1.2,6.4-1,14.8-.7,17.5,0,.3,0,.8.2,1.6-2.1,3.5-4.8,7.6-6.4,7.7-2.1.2-1.5-1.7-2.9-6.1-.2-.6-.9-3.3-4.2-3.2-1.6,0-3.3.5-5.6,3-3.7,4.1-12.3,10.2-18.4,6.4-.7-.5-4-3.2-2.7-11.3.4-2.2,1-4.4,2-6.4.9-2,2.1-4,3.4-5.6,6.3-7.7,11.7-8.6,12.8-8.5,2.7,0,3.5,3.6,3.5,3.5,0,.6.6,1.1,1.2,1,.6,0,1.1-.6,1-1.2,0,0,0-1.2-.5-2.2-.4-1.4-1.7-2.7-2.4-3.2-3.4-2.4-11.2-.5-18.7,8.2-1.5,1.9-2.9,4.1-3.9,6.4-1.1,2.3-1.9,4.8-2.3,7.5-2,14.3,6.7,16.6,8.2,16.9,7.6.9,13.3-3.3,15.9-5.8,1,4.8,5.7,4.8,7.8,2.7.5-.6,1-1.2,1.3-1.9,1.2,4.5,5.2,3,5.7,2.8,2.2-.8,4.5-3.9,6.2-6.5,1,3.6,3.1,7.4,6.9,6.9,2.3,0,8.2-6.3,8.7-5.5.5.7.7,1.9.6,3.7,0,1.8,1.4,1.9,2.1,1.7,1-.3,1.7-2.3,2.7-4,.8-1.4,1.5-2.1,2.3-3.1.4-.5,2.3-2.4,3.7-1.7,1.3.7,1.5,2,1.6,2.8.1.8.1,1.6.1,2.4,0,3,1.4,3.5,1.8,3.6,3.3.9,3.5-5.3,5.9-7.6.2-.2,2.3-2.4,3.6,1.1,1.7,6.4,7.1,8.9,14.4,5.3,1.3-.7,1.6-.9,2.3-1.5.3-.2.4-.6.2-.9ZM44.1,62.8c-1.4,3-4.6,2.8-4.6-.4,0-3.3,4.2-5.4,5.3-3.1,0,.2.2.4.2.6-.2.6-.3,1.6-.9,2.9ZM61.9,34.9c.6,1.1,1.9,8.2-1.7,15.9,0-.2,0-.5,0-.7,0-12.5,1.6-15.4,1.7-15.2Z"
        fill="#fff"
      />
      <path
        d="M17.2,78.2h3v8.9h10.9v-8.9h3v21.3h-3v-9.8h-10.9v9.8h-3v-21.3Z"
        fill="#fff"
      />
      <path
        d="M53.4,93.2h-11.4c0,1.2.6,2.3,1.5,3.1.9.8,2,1.3,3.2,1.2.8,0,1.7-.2,2.4-.6.7-.4,1.4-.9,1.8-1.6l2,1.6c-.7,1-1.7,1.7-2.7,2.2-1.1.5-2.3.8-3.5.7-4.4,0-7.6-3-7.6-7.5s3.2-7.5,7.4-7.5,6.9,2.8,6.9,7.4c0,.4,0,.7,0,1ZM50.5,91.1c0-2.2-1.4-4-4-4-1.1,0-2.2.4-3.1,1.1-.8.8-1.4,1.8-1.5,2.9h8.6Z"
        fill="#fff"
      />
      <path
        d="M67.6,90.3c0-2.2-1.4-3.1-3.6-3.1s-3,.6-4.1,1.7l-1.5-1.8c1.6-1.4,3.7-2.2,5.9-2.2,4.1,0,6,2.5,6,5.6v6.2c0,1,0,1.9.2,2.8h-2.6c-.2-.7-.2-1.4-.2-2.1h0c-.5.8-1.3,1.4-2.1,1.8-.9.4-1.8.6-2.7.6-2.3,0-5.2-1.1-5.2-4.4s5.2-4.8,10.1-4.8v-.4ZM67,92.7c-2.8,0-6.4.3-6.4,2.7s1.5,2.2,2.9,2.2c2.7,0,4.2-1.8,4.2-4.2v-.7h-.7Z"
        fill="#fff"
      />
      <path d="M78.6,99.5h-2.8v-22.8h2.8v22.8Z" fill="#fff" />
      <path
        d="M92.5,87.5h-3.8v7.4c0,1.7.6,2.4,2.1,2.4s1.2-.1,1.7-.4v2.3c-.7.3-1.5.4-2.3.4-2.7,0-4.2-1.5-4.2-4.5v-7.8h-2.7v-2.3h2.8v-4.1h2.8v4.1h3.8v2.3Z"
        fill="#fff"
      />
      <path
        d="M100.5,87.4c.5-.8,1.1-1.5,1.9-1.9.8-.5,1.7-.7,2.6-.7,3.7,0,5.4,2.6,5.4,5.8v8.8h-2.8v-7.9c0-2.3-.6-4.4-3.3-4.4s-3.9,1.9-3.9,4.7v7.5h-2.8v-22.8h2.8v10.7h0Z"
        fill="#fff"
      />
    </svg>
  </Icon>
);
